import React from "react";
import { Field } from "formik";
import { useMediaQuery } from "@mui/material";
import AssetQuantityField from "../../../views/inventory/requests/AssetQuantityField";

export default function LocationQuantityField({ name, location, size = "small", disabled = false }) {
  const isMobile = useMediaQuery(theme => theme.breakpoints.down("md"));
  const value = location.sub_qty + (location.restock_sub_qty || 0);

  return (
    <Field name={name}>
      {({ field, form }) => {
        return (
          <AssetQuantityField
            disabled={disabled}
            displayButtons={!isMobile}
            size={size}
            quantity={value}
            onChange={quantity =>
              form.setFieldValue(field.name, (quantity || 0) - location.sub_qty)
            }
            quantityProps={{
              label: "Location QTY",
              style: { minWidth: isMobile ? 95 : 110, width: isMobile ? "100%" : undefined },
              InputLabelProps: {
                shrink: true,
              },
            }}
          />
        );
      }}
    </Field>
  );
}
